import thunk from 'redux-thunk';
import multi from 'redux-multi';
import reduxCatch from 'redux-catch';
import timerMiddleware from './timerMiddleware';
// import logger from 'redux-logger';

const errorHandler = (error, getState, lastAction, dispatch) => {
  console.error(error);
};

const rootMiddleware = addMiddleware => [thunk, multi, timerMiddleware, reduxCatch(errorHandler), ...addMiddleware];

export default rootMiddleware;
